// extracted by mini-css-extract-plugin
export default {"chooseInterests":"ChooseInterests_chooseInterests__0Lncn","content":"ChooseInterests_content__Uv6zc","loader":"ChooseInterests_loader__xjIib"};